// moms-harness:anchor v2
// Spec: docs/spec/auth/LOGISPRD-10053-okta-app-access-denied.yaml

import type { ReactNode } from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'
import { Icon } from '@musinsa/pbo-assets'
import type { BasicIconName } from '@musinsa/pbo-assets'
import { Typography } from '@musinsa/layer-components-desktop'

type AuthStatusPageProps = {
  iconName: BasicIconName
  title: string
  description: string
  children: ReactNode
}

function AuthStatusPage({ iconName, title, description, children }: AuthStatusPageProps) {
  return createPortal(
    <Wrap>
      <Inner>
        <IconTextWrap>
          <Icon name={iconName} filled size={80} colorToken="gray-300" />
          <Title name="base-title-xl-medium" colorToken="fg">
            {title}
          </Title>
          <Description name="base-text-xl" colorToken="fg-low">
            {description}
          </Description>
        </IconTextWrap>
        <ButtonBlock>{children}</ButtonBlock>
      </Inner>
    </Wrap>,
    document.body,
  )
}

export default AuthStatusPage

const Wrap = styled.div`
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
`

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  width: min(335px, calc(100vw - 40px));
`

const IconTextWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  width: min(296px, 100%);
`

const Title = styled(Typography)`
  text-align: center;
  white-space: pre-line;
  word-break: keep-all;
`

const Description = styled(Typography)`
  text-align: center;
  white-space: pre-line;
  word-break: keep-all;
`

const ButtonBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  width: 100%;

  & > button {
    width: 100%;
  }
`
